






































































































































































































































import { Component, Vue } from "vue-property-decorator";
import request from "@/api/index";
import Base from "@/template/public/Base.vue";
import native from "@/common/Native";
import store from "@/store";
import { Icon } from "vant";
import { Base64 } from "js-base64";
import { wxChatShare } from "@/common/wechat";
import { wxChatJumpApp } from "@/common/wechatapp";
import { findNameByAppconfig } from "@/common/Utils";
import AppPrompt from "@/components/AppPrompt.vue";
import {
  dateFormat,
  setImgSrc,
  findNameByIdInApp,
  findNameByWechatAppid
} from "@/common/Utils";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    vanIcon: Icon,
    AppPrompt
  }
})
export default class AskGovDetails extends Base {
  public request = new request();
  private locaImg = require("../../assets/location.png");
  private stepStrip = require("../../assets/step_strip.png");
  private noImg = require("../../assets/bn默认无图.png");
  private dataInfo: any = {};
  private score: string = "0";
  public appId: string = "";
  public id: string = "";
  private isRequestLoaded: boolean = false; //详情是否加载完成
  private userInfo: any = {
    token: "",
    sessionId: "",
    phone: ""
  };
  private isOpenInApp: boolean = false;
  private appName: string = "";
  loadding: boolean = true;
  isShow: boolean = true;
  wxAppId: any;
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.appId = this.$route.query.appId as string;
    this.id = (this.$route.query.cid || this.$route.query.id) as string;
    if (native.isOpenInApp()) {
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        store.commit("SET_STATE", response);
        this.isOpenInApp = true;
        this.getDetail();
      });
    } else {
      this.isOpenInApp = false;
      this.getDetail();
    }
  }
  mounted() {
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "";
    this.appName = findNameByIdInApp(this.$store.state.appInfo, this.appId);
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
  }
  changeScore(num: string) {
    this.score = num;
  }
  subScore() {
    if (this.score === "0") {
      return;
    }
    let params = {
      appId: this.appId,
      id: this.id,
      score: String(this.score)
    };
    this.request.subWzScore(params).then(res => {
      if (res.code === 0) {
        this.$set(this.dataInfo, "serviceScore", this.score);
      }
    });
  }
  getDetail() {
    let params = { appId: this.appId, id: this.id, sessionId: "", token: "" };
    this.request.getWzDetails(params).then(async res => {
      if (res.code === 0) {
        this.dataInfo = res.data;
        document.title = res.data.title;
        // this.getBaseappInfoConfigList(this.dataInfo.appId);
        await this.getShareInfo(this.dataInfo.appId);
        this.isRequestLoaded = true;
        this.loadding = false;
        this.isShow = res.data.eventProgress.length != 0;
        var appInfo = this.$store.state.appInfo;
        var appConfig = findNameByAppconfig(
          appInfo,
          this.appId || (this.$route.query.appId as string)
        );
        // wxChatShare(
        //   res.data.title,
        //   res.data.content,
        //   window.location.href,
        //   this.shareInfo.shareLogo
        // );
        const linkUrl = window.location.href;
        const wechatConfigId = appConfig.wechatConfigId;
        if (
          linkUrl &&
          appConfig.realmUrl &&
          linkUrl.indexOf(appConfig.realmUrl) != -1
        ) {
          wxChatJumpApp(
            wechatConfigId,
            res.data.title,
            res.data.content,
            window.location.href,
            this.shareInfo.shareLogo
          );
        } else {
          wxChatShare(
            res.data.title,
            res.data.content,
            window.location.href,
            this.shareInfo.shareLogo
          );
        }
        this.lazyHandle();
        // 埋点
        this.endTime = time();
        if (this.dataSource) {
          getData(this.startTime, this.endTime, this.dataInfo);
          this.dataSource = false;
        }
      } else {
        this.isRequestLoaded = true;
        this.loadding = false;
        this.isShow = false;
      }
    });
  }
  //懒加载处理
  lazyHandle() {
    //图片视频的懒加载
    class LazyImage {
      private imageElements: Array<Element> = [];
      private _throttleFn: any;
      constructor() {
        this.imageElements = Array.prototype.slice.call(
          document.querySelectorAll(".article-detail img[data-original]")
        );
        // alert(this.imageElements)
        this.init();
      }
      init() {
        this.inViewShow();
        this._throttleFn = this.throttle(this.inViewShow);
        addEvent(
          document.querySelector("#app"),
          "scroll",
          this._throttleFn.bind(this),
          false
        );
        // }
      }
      inViewShow() {
        let len = this.imageElements.length;
        // console.log("scroll");
        for (let i = 0; i < len; i++) {
          let imageElement = this.imageElements[i];
          let rect = imageElement.getBoundingClientRect();
          // 出现在视野的时候加载图片
          if (rect.top < document.documentElement.clientHeight) {
            let dataSrc = imageElement.getAttribute("data-original") as string;
            let dataSrc2 = imageElement.getAttribute("src") as string;
            dataSrc && imageElement.setAttribute("src", dataSrc);
            imageElement.removeAttribute("data-original");
            imageElement.setAttribute("data-original2", dataSrc);
            // 移除掉已经显示的
            this.imageElements.splice(i, 1);
            len--;
            i--;
            if (this.imageElements.length === 0) {
              // 如果全部都加载完 则去掉滚动事件监听
              // document.removeEventListener('scroll', this._throttleFn)
              removeEvent(document, "scroll", this._throttleFn, false);
            }
          }

          imageElement.addEventListener("error", function(e: any) {
            let datasrc = imageElement.getAttribute("data-original2") as string;
            imageElement.setAttribute("src", datasrc);
          });
        }
      }
      throttle(fn: any, delay: number = 15, mustRun: number = 30) {
        let t_start: number | null = null;
        let timer: any = null;
        let context = this;
        return function() {
          let t_current = +new Date();
          let args = Array.prototype.slice.call(arguments);
          clearTimeout(timer);
          if (!t_start) {
            t_start = t_current;
          }
          if (t_current - t_start > mustRun) {
            fn.apply(context, args);
            t_start = t_current;
          } else {
            timer = setTimeout(function() {
              fn.apply(context, args);
            }, delay);
          }
        };
      }
    }
    new LazyImage();
    //兼容IE浏览器
    // 事件绑定
    function addEvent(element: any, eType: any, handle: any, bol: any) {
      if (element.addEventListener) {
        //如果支持addEventListener
        element.addEventListener(eType, handle, bol);
      } else if (element.attachEvent) {
        //如果支持attachEvent
        element.attachEvent("on" + eType, handle);
      } else {
        //否则使用兼容的onclick绑定
        element["on" + eType] = handle;
      }
    }
    // 事件解绑
    function removeEvent(element: any, eType: any, handle: any, bol: any) {
      if (element.addEventListener) {
        element.removeEventListener(eType, handle, bol);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eType, handle);
      } else {
        element["on" + eType] = null;
      }
    }
  }
  jumpToDetail(data: any) {
    if (this.isOpenInApp) {
      ZWY_CLOUD.redirectUrl({
        id: data.infoClassifyId,
        sourceId: data.infoClassifyId,
        detailViewType: data.detailViewType,
        sourceType: data.sourceType,
        commentType: data.commentType,
        contextType: data.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "0",
        url: data.url,
        shareUrl: data.url,
        title: Base64.encode(data.title), //base 64
        synopsis: Base64.encode(data.synopsis), //base 64
        shareImgUrl: data.shareImgUrl
      });
    } else {
      window.open(data.url);
    }
  }
  relLink() {
    if (this.isOpenInApp) {
      ZWY_CLOUD.redirectUrl({
        id: "",
        sourceId: "",
        sourceType: "2",
        detailViewType: "98",
        commentType: "0",
        isShowBottom: "0",
        isShowMore: "0",
        isShowTop: "1",
        shareImgUrl: "",
        shareUrl: window.location.href,
        synopsis: Base64.encode(""),
        title: Base64.encode(""),
        url: encodeURI(this.dataInfo.corrInfoClissifyUrl),
        contextType: "1"
      });
    } else {
      if (this.dataInfo.corrInfoClissifyUrl) {
        window.open(this.dataInfo.corrInfoClissifyUrl);
      }
    }
  }
  wxopenApp() {
    (this.$refs.openapp_prompt as any).openApp();
  }
}
